import { Link } from 'react-router-dom'

export default function ReportsHubScreen() {
  return (
    <>
      <div className="topbar">
        <div className="crumb"><b>Reports</b></div>
      </div>
      <div className="pc" data-testid="reports-hub">
        <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 22, margin: '0 0 16px' }}>Reports</h1>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <Link to="/reports/operations" className="panel" data-testid="reports-hub-operations" style={{ padding: 16, minWidth: 220, textDecoration: 'none' }}>
            <div style={{ fontWeight: 700 }}>Operations report</div>
            <div style={{ fontSize: 13, color: 'var(--ink3)' }}>Billed, collected, outstanding</div>
          </Link>
          <Link to="/reports/owner-statement" className="panel" data-testid="reports-hub-owner-statement" style={{ padding: 16, minWidth: 220, textDecoration: 'none' }}>
            <div style={{ fontWeight: 700 }}>Owner statement</div>
            <div style={{ fontSize: 13, color: 'var(--ink3)' }}>What the owner owes</div>
          </Link>
        </div>
      </div>
    </>
  )
}
